import { useState } from 'react'
import Holiday from './Holiday'
import EditHolidayModal from 'pages/Modals/EditHolidayModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function HolidayList ({
  holidays = [],
  onEdit: handleEdit = () => {}
}) {
  const [holidayData, setHolidayData] = useState (null)
  const [showEditHolidayModal, setShowEditHolidayModal] = useState (false)

  const editHoliday = date => {
    setHolidayData (date)
    toggleEditHolidayModal ()
  }

  const toggleEditHolidayModal = () => setShowEditHolidayModal (!showEditHolidayModal)

  if (holidays.length === 0) return (
    <Container>
      <InfoText>Nenhum feriado encontrado</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Atender a Cutilei</SubTitle>
        <SubTitle>Data</SubTitle>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Horário inicial</SubTitle>
        <SubTitle>Horário final</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {holidays.map (holiday => (
        <Holiday
          key={holiday.id}
          data={holiday}
          onEdit={editHoliday}
          onUpdated={handleEdit}
        />
      ))}
      {!!holidayData && (
        <EditHolidayModal
          visible={showEditHolidayModal}
          data={holidayData}
          onConfirm={handleEdit}
          onClose={toggleEditHolidayModal}
        />
      )}
    </Container>
  )
}
